/**
 * AlmadarPostIkeaEffectSoftwareENPostPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait AlmadarPostIkeaEffectSoftwareENPostPage
 */

import { useAlmadarPostIkeaEffectSoftwareENPostPageLogic } from '@/hooks/traits/useAlmadarPostIkeaEffectSoftwareENPostPageLogic';
import type { AlmadarPostIkeaEffectSoftwareENPostPageConfig } from '@/hooks/traits/useAlmadarPostIkeaEffectSoftwareENPostPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { AlmadarPostIkeaEffectSoftwareENPostView as AlmadarPostIkeaEffectSoftwareENPostViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Box } from '@almadar/ui/components';
import { Container } from '@almadar/ui/components';
import { AlmadarPostIkeaEffectSoftwareENPostHeaderView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareENPostHeaderView';
import { AlmadarPostIkeaEffectSoftwareENPostFooterView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareENPostFooterView';
import { AlmadarPostIkeaEffectSoftwareENPostView } from '@/components/traits/AlmadarPostIkeaEffectSoftwareENPostView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface AlmadarPostIkeaEffectSoftwareENPostPageViewProps {
  config?: Partial<AlmadarPostIkeaEffectSoftwareENPostPageConfig>;
}

export function AlmadarPostIkeaEffectSoftwareENPostPageView({ config: propsConfig }: AlmadarPostIkeaEffectSoftwareENPostPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useAlmadarPostIkeaEffectSoftwareENPostPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['AlmadarPostIkeaEffectSoftwareENPostView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="AlmadarPostIkeaEffectSoftwareEN" trait="AlmadarPostIkeaEffectSoftwareENPostPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="AlmadarPostIkeaEffectSoftwareENPostPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><AlmadarPostIkeaEffectSoftwareENPostHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box fullWidth={true} bg="transparent" paddingY="xl"><Container maxWidth="xl" size="xl" padding="lg"><AlmadarPostIkeaEffectSoftwareENPostView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Container></Box><AlmadarPostIkeaEffectSoftwareENPostFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default AlmadarPostIkeaEffectSoftwareENPostPageView;
